import type { useCatalogGridModel } from '@/components/catalog/catalog-grid/catalog-grid.model'
import { ProductCardViewModel } from '@/components/shared/product-card/product-card.view-model'

type CatalogGridViewProps = ReturnType<typeof useCatalogGridModel>

export function CatalogGridView({ cards }: CatalogGridViewProps) {
  return (
    <div className="fz-catalog-grid">
      {cards.map(({ product, size }) => (
        <ProductCardViewModel
          key={product.slug}
          product={product}
          size={size}
        />
      ))}
    </div>
  )
}
